import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import sanitizeHtml from 'sanitize-html';

const StyledText = styled.div<{ textStyle?: CSSProperties }>(
  ({ textStyle }) => ({
    textAlign: 'center',
    ...textStyle,
  }),
);

export interface TextProps {
  text?: string;
  s?: CSSProperties;
}

const safetyHtml = (text: string) => sanitizeHtml(text, { allowedTags: [] });

function ProductText({ text, s }: TextProps) {
  if (!text) return null;
  return (
    <StyledText
      textStyle={s}
      dangerouslySetInnerHTML={{ __html: safetyHtml(text) }}
    />
  );
}

export default ProductText;
